<ng-container *ngIf="exercises.length; else empty">
    <stats-pie-chart [options]="options"></stats-pie-chart>

    <div class="metrics-details-container">
        <app-metrics-item *ngFor="let exercise of exercises"
                          [title]="exercise.exerciseName"
                          [backgroundColors]="[exercise.accent1Color, exercise.accent2Color, exercise.accent3Color]"
                          [mainMetricValue]="((exercise.occurrence / exercise.totalOccurrence) | percent:'1.0-1') ?? ''"
                          [mainMetricUnit]="''"
                          [legend]="exercise.occurrence + ' x'"
                          (onClicked)="onShowClicked(exercise)">
        </app-metrics-item>
    </div>
</ng-container>

<ng-template #empty>
    <app-stats-empty *ngIf="loaded"></app-stats-empty>
</ng-template>
